export default __webpack_public_path__ + "static/media/shop.26e6a34d.mp4";